import Vue from 'vue'
import Router from 'vue-router'
import Cookie from 'js-cookie'
import Login from '@/pages/Login';
import registered from '@/pages/registered';
import updatePassword from '@/pages/updatePassword';
import Home from '@/pages/Home';
import index from '@/pages/index';
import college from '@/pages/college';
import collegeDetail from '@/pages/collegeDetail';
import engineer from '@/pages/engineer';
import enterprise from '@/pages/enterprise';
import engineerDetail from '@/pages/engineerDetail';
import enterpriseDetail from '@/pages/enterpriseDetail';
import view from '@/pages/view';
import search from '@/pages/search';
import pngView from '@/pages/pngView';
import recruitment from '@/pages/recruitment';
import recruitmentDetail from '@/pages/recruitmentDetail';
import user from '@/pages/user';
import applyRecruitment from '@/pages/applyRecruitment';
import brand from '@/pages/brand';
import job from '@/pages/job';
import webVideo from '@/pages/webVideo';
import webVideoDetails from '@/pages/webVideo/details';
Vue.use(Router)

var router= new Router({
  routes: [
    //重定向
    {
      path: '/',
      redirect: '/index'
    },
    
    {
      path: '/home',
      component: Home,
      children: [
        {
          path: '/login',
          component: Login,
          name:'登录'
        },
        {
          path: '/registered',
          component: registered,
          name:'注册'
        },
        {
          path: '/updatePassword',
          component: updatePassword,
          name:'修改密码'
        },
        {
          path: '/index',
          component: index,
          name:'首页'
        },
        {
          path: '/college',
          component: college,
          name:'学院'
        },
        {
          path: '/collegeDetail',
          component: collegeDetail,
          name:'学院详情'
        },
        {
          path: '/engineer',
          component: engineer,
          name:'工程师'
        },
        {
          path: '/enterprise',
          component: enterprise,
          name:'工控企业'
        },
        {
          path: '/engineerDetail',
          component: engineerDetail,
          name:'工程师详情'
        },
        {
          path: '/enterpriseDetail',
          component: enterpriseDetail,
          name:'工控企业详情'
        },
        {
          path: '/view',
          component: view,
          name:'pdf'
        },
        {
          path: '/search',
          component: search,
          name:'搜索'
        },
        {
          path: '/pngView',
          component: pngView,
          name:'图片'
        },
        {
          path: '/recruitment',
          component: recruitment,
          name:'招聘信息'
        },
        {
          path: '/recruitmentDetail',
          component: recruitmentDetail,
          name:'招聘详情'
        },
        {
          path: '/user',
          component: user,
          name:'个人中心'
        },
        {
          path: '/applyRecruitment',
          component: applyRecruitment,
          name:'发布职位'
        },
        {
          path: '/brand',
          component: brand,
          name:'品牌详情'
        },
        {
          path: '/job',
          component: job,
          name:'求职信息'
        },
        {
          path: '/webVideo',
          component: webVideo,
          name:'网络视频'
        },
        {
          path: '/webVideoDetails',
          component: webVideoDetails,
          name:'网络视频详情'
        }
        
        
      ]
    },

  ]
})
router.beforeEach((to,form,next)=>{
   if(Cookie.get('id')){
    // router.app.$options.store.commit('updateName',to.name)
    console.log()
    if (to.path!='/login'){
      next()
    }else{
      next({
        path:'/index'
      })
      
    }
   }else {
    next()
    //  if (to.path!='/login'){
    //    next({
    //      path:'/login'
    //    })
    //  } else {
      
    //    next()
    //  }
   }
  // next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js